import { Routes, Route } from "react-router-dom";

import Error404 from "../pages/errors/Error404";
import About from "../pages/client/about/About";
import Blogs from "../pages/client/blogs/Blogs";
import Events from "../pages/client/events/Events";
import Landing from "../pages/client/landing/Landing";
import Projects from "../pages/client/projects/Projects";
import BlogDetail from "../pages/client/blogs/BlogDetail";
import EventDetail from "../pages/client/events/EventDetail";
import Businesses from "../pages/client/businesses/Businesses";
import Attractions from "../pages/client/attractions/Attractions";
import ProjectDetail from "../pages/client/projects/ProjectDetail";
import BusinessDetail from "../pages/client/businesses/BusinessDetail";
import Announcements from "../pages/client/announcements/Announcements";
import AnnouncementDetail from "../pages/client/announcements/AnnouncementDetail";
import AttractionDetail from "../pages/client/attractions/AttractionDetail";
import Scholarships from "../pages/client/scholarships/Scholarships";
import ScholarshipDetail from "../pages/client/scholarships/ScholarshipDetail";

const ClientRoutes = () => {
  return (
    <Routes>
      {/* Landing page - index route */}
      <Route index element={<Landing />} />
      {/* Client pages */}
      <Route path="about" element={<About />} />
      <Route path="projects" element={<Projects />} />
      <Route path="projects/:id" element={<ProjectDetail />} />
      <Route path="events" element={<Events />} />
      <Route path="events/:id" element={<EventDetail />} />
      <Route path="announcements" element={<Announcements />} />
      <Route path="announcements/:id" element={<AnnouncementDetail />} />
      <Route path="blogs" element={<Blogs />} />
      <Route path="blogs/:id" element={<BlogDetail />} />
      <Route path="businesses" element={<Businesses />} />
      <Route path="businesses/:id" element={<BusinessDetail />} />
      <Route path="attractions" element={<Attractions />} />
      <Route path="attractions/:id" element={<AttractionDetail />} />
      <Route path="scholarships" element={<Scholarships />} />
      <Route path="scholarships/:id" element={<ScholarshipDetail />} />
      {/* Catch all for client routes - 404 */}
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
};

export default ClientRoutes;
